import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Apps } from "./main-app";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Apps />
  </StrictMode>
);
